export default "__VITE_ASSET__a559fa90__"